import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

import { ItineraryDetail, AirValidationFlightsSector, TripTypes } from '@seat-map/entities/itinerary-detail';
import { SeatMapFacade } from '@seat-map/seat-map.facade';
import { PassengersSeatMap, PassengersSeats } from '@seat-map/entities/seat-map';
import { SeatMapAbstract } from '@seat-map/components/abstracts/seat-map.abstract';
import { AppFacade } from '@app/app.facade';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { MobileDeviceService } from '@app/services/mobile-device.service';
import { AvoService } from '@avo/services/avo.service';

@Component({
  selector: 'app-seat-map-desktop',
  templateUrl: './seat-map-desktop.component.html',
  styleUrls: ['./seat-map-desktop.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SeatMapDesktopComponent extends SeatMapAbstract implements OnInit, OnDestroy {

  constructor(
    protected facade: SeatMapFacade,
    protected appFacade: AppFacade,
    protected router: Router,
    protected domManiputaleService: DomManipulateService,
    protected translateService: TranslocoService,
    protected mobileDeviceService: MobileDeviceService,
    protected avoService: AvoService,
  ) {
    super(facade, appFacade, router,
      domManiputaleService, translateService, mobileDeviceService, avoService);
  }

  ngOnInit(): void {
    this.subscriptions.push(this.itineraryDetail$.subscribe(itinerary => {
      this.itineraryDetail = itinerary;
    }));

    this.subscriptions.push(this.seatMapTransactions$.subscribe(transactions => {
      this.seatMapTransactions = transactions;
    }));

    this.subscriptions.push(this.showError$.subscribe(showError => {
      this.showError = showError;
      this.registerAmplitudeEventErrors();
    }));
    this.domManiputaleService.setBodyScroll(true);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public departureFlights(itinerary: ItineraryDetail): AirValidationFlightsSector[] {
    if (itinerary?.Sectors?.length > 0) {
      return itinerary?.Sectors[0]?.Flights;
    } else {
      return null;
    }
  }

  public enableConfirm(passengersSeats: PassengersSeats[]): boolean {
    return passengersSeats && passengersSeats.filter(x => !x.SeatNumber).length === 0;
  }

  public arrivalFlights(itinerary: ItineraryDetail): AirValidationFlightsSector[] {
    if (itinerary?.Sectors?.length > 1) {
      return itinerary.Sectors[1].Flights;
      
    } else {
      return null;
    }
  }

  public selectFlight(itineraryDetail: ItineraryDetail, sectorNumber: number, flight: AirValidationFlightsSector): void {
    this.facade.selectSectorItineraryDetail(sectorNumber);
    this.facade.selectFlightItineraryDetail(flight);
    this.facade.fetchSeatMapFlight(itineraryDetail.Id, itineraryDetail.AirReservationId,
      this.getFlightIx(itineraryDetail, sectorNumber, flight),
      itineraryDetail.Passengers as PassengersSeatMap[]);
  }

  public flightLatest(flight: AirValidationFlightsSector, flights: AirValidationFlightsSector[]): boolean {
    return flights[flights.length - 1] === flight;
  }

  public sectorType(sectorNumber: number): string {
    return `FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.${sectorNumber === TripTypes.DEPARTURE ?
      'DEPARTURE_TRIP' : 'RETURN_TRIP'}`;
  }

  public removeSeatInFlight(seatNumber: string): void {
    this.facade.removeSeatInFlightAction(seatNumber);
  }

}
